// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type SetMailboxCalendarConfigurationRequest from "../contract/SetMailboxCalendarConfigurationRequest";

export default function setMailboxCalendarConfigurationRequest(data: SetMailboxCalendarConfigurationRequest): SetMailboxCalendarConfigurationRequest {
    const result: SetMailboxCalendarConfigurationRequest = {
        __type: "SetMailboxCalendarConfigurationRequest:#Exchange",
        ...data,
    };
    
    return result;
}
